import { render } from "./FileSource.vue?vue&type=template&id=12655267&ts=true"
import script from "./FileSource.vue?vue&type=script&lang=ts"
export * from "./FileSource.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__